import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {TdoEnterpriseConfigurationModel} from '../models/configuration/tdo-enterprise-configuration.model';
import {TdoClientConfigurationModel} from '../models/clients/tdo-client-configuration.model';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {
  tdoDomain = '';

  constructor(private http: HttpClient) {
    //
    this.tdoDomain = window.location.hostname;
  }

  getEnterprise(): Observable<TdoEnterpriseConfigurationModel> {
    return this.http.get<TdoEnterpriseConfigurationModel>(`api/enterprise/get-enterprise/${this.tdoDomain}`)
      .pipe(catchError(this.handleError<any>('getEnterprise')));
  }

  getEnterpriseById(enterpriseId: string) {
    return this.http.get<TdoEnterpriseConfigurationModel>(`api/enterprise/get-enterprise-by-id/${enterpriseId}`);
  }

  getClients(): Observable<TdoClientConfigurationModel[]> {
    return this.http.get<TdoClientConfigurationModel>(`api/enterprise/get-clients`)
      .pipe(catchError(this.handleError<any>('getClients')));
  }

  saveTDOClient(client: TdoClientConfigurationModel): Observable<TdoClientConfigurationModel> {
    return this.http.post<TdoClientConfigurationModel>(`/api/enterprise/save-client`, client);
  }

  // Private
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  private handleError<T>(operation = 'TdoService', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }
}
